import { createSelector } from 'reselect';
import { freeShippingProgressBarAtbSelector } from 'selectors/testTarget/offers/freeShippingProgressBarAtb/freeShippingProgressBarAtbSelector';

/**
 * Returns the raw experience string for the Free Shipping Progress Bar ATB offer.
 *
 * @param {object} state Redux state.
 * @returns {string|undefined} The experience value, or undefined when missing.
 */
const experienceSelector = createSelector(freeShippingProgressBarAtbSelector, ({ experience }) => experience);

export { experienceSelector };
